<template>
	<div class="scrollable only-y">
	<div class="page-header card-base card-shadow--medium" v-loading="loadingDetail" element-loading-background="rgba(0, 0, 0, 0.8)">
		<h2 class="no-m white-text"><i class="mdi mdi-bank widget-icon accent-text fs-30"></i> {{ $t('menu.finance') }}</h2>
	</div>
	<el-card>
		<el-tabs type="border-card" v-model="activeTab" @tab-click="tabClick">
			<el-tab-pane label="Topup Quota" name="capping_quota">
				<div>
					<el-col :span="24" :md="24" :sm="24" :xs="24">
						<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;">
							Total Consuments : <br>
							<span style="font-size:32px;">{{ (totalCaping) }}</span>
						</el-card>
					</el-col>
				</div>
				<template>
					<div class="row">
						<el-row :gutter="30">
							<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :loading="loadingBtn">
								<el-card shadow="none">
									<el-form :model="ruleFormCaping" status-icon :rules="rules" ref="ruleFormCaping" label-width="150px">
										<el-form-item label="Product Name" prop="selectedProduct">
											<el-select
												:style="{ width: '100%'}"
												filterable
												disabled
												v-model="ruleFormCaping.selectedProductName" placeholder="Select Product Name"
												@change="loadCompanyCaping()">
												<el-option
													v-for="(p,i) in products_name" :key="i"
													:label="p.name == 'Whatsapp Conversation' ? 'Whatsapp Conversation' : 'Whatsapp Notification'"
													:value="p.name">
												</el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="Product Type" prop="selectedProduct">
											<el-select
												:style="{ width: '100%'}"
												filterable
												v-model="ruleFormCaping.selectedProduct" placeholder="Select Product"
												@change="loadCompanyCaping()">
												<el-option
													v-for="(p,i) in products_notif" :key="i"
													:label="p.name == 'notification_caping' ? 'Notification Caping (CBP Caping)' : 'Notification Caping Plafon (CBP Hybrid)'"
													:value="p.name">
												</el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="Company" prop="selectedCompany">
											<el-select
												:style="{ width: '100%'}"
												filterable
												v-model="ruleFormCaping.selectedCompany" placeholder="Select Company" v-loading="loadingNumberCaping">
												<el-option
													v-for="(c,ind) in costumersCaping" :key="ind"
													:label="c.customer_name"
													:value="c.customer_id">
												</el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="Phone Number" prop="selectedPhoneNumber">
											<el-select
												:style="{ width: '100%'}"
												filterable
												v-model="ruleFormCaping.selectedPhoneNumber" placeholder="Select Number Phone" v-loading="loadingNumberCaping">
												<el-option
													v-for="(numb,index) in numberCaping" :key="index"
													:label="numb.number"
													:value="numb.number">
												</el-option>
											</el-select>
										</el-form-item>
										<el-form-item label="CBP Current Quota" v-if="ruleFormCaping.selectedPhoneNumber != ''">
											<el-input :style="{ width: '100%'}" v-model="dataQuota" auto-complete="off" disabled v-loading="saldoLoading">{{quota}}</el-input>
										</el-form-item>
										<el-form-item label="UI Current Quota" v-if="ruleFormCaping.selectedPhoneNumber != ''">
											<el-input :style="{ width: '100%'}" v-model="dataQuotaUI" auto-complete="off" disabled v-loading="saldoLoading">{{quota}}</el-input>
										</el-form-item>
										<el-form-item label="BI Current Quota" v-if="ruleFormCaping.selectedPhoneNumber != ''">
											<el-input :style="{ width: '100%'}" v-model="dataQuotaBI" auto-complete="off" disabled v-loading="saldoLoading">{{quota}}</el-input>
										</el-form-item>
										<el-form-item label="Topup Type">
											<template>
												<el-radio v-model="ruleFormCaping.topuptype" label="Added">Added</el-radio>
												<el-radio v-model="ruleFormCaping.topuptype" label="Minus">Minus</el-radio>
											</template>
										</el-form-item>
										<el-form-item label="Note" prop="reason">
											<el-input class="mt-10" v-model="ruleFormCaping.reason" :rows="5" type="textarea" placeholder="Mohon berikan alasan"></el-input>
										</el-form-item>
									</el-form>
								</el-card>
								<el-card shadow="none" class="mt-10"  v-for="(o, keys) in ruleFormCaping.detail" :key="keys">
									<template>
										<el-form :model="ruleFormCaping" status-icon :rules="rules" ref="ruleFormCaping" label-width="150px">
											<el-form-item label="Token Type" prop="tokenType">
												<el-input readonly
													:style="{ width: '100%'}"
													v-model="ruleFormCaping.detail[keys].tokenType" placeholder="Select Token Type" @change="disabledOption">
													<!-- <el-option
														v-for="(tokentype,k) in token_type" :key="k"
														:label="tokentype.name"
														:value="tokentype.value"
														:disabled="tokentype.disabled">
													</el-option> -->
												</el-input>
											</el-form-item>
											<el-form-item label="Quota" prop="quota">
												<el-input-number v-model="ruleFormCaping.detail[keys].quota" controls-position="right" @change="handleChange" :min="0"></el-input-number>
											</el-form-item>
										</el-form>
									</template>
									<!-- <el-button v-if="ruleFormCaping.detail.tokenType=='null'" size="small" type="danger" style="display: none; float:right;" @click="ruleFormCaping.detail.splice(keys, 1)"><i class="mdi mdi-delete"/> Remove Token Type</el-button>
									<el-button v-else type="danger" size="small" style="float:right; margin-top: 10px; margin-right: 1%; margin-bottom: 20px;" @click="deleteDataType(keys)"><i class="mdi mdi-delete"/> Remove Token Type</el-button> -->
								</el-card>
								<!-- <el-button size="small" type="success" round @click="clickAddType" v-if="ruleFormCaping.detail.length==3" disabled class="mt-10">
									Add Token Type
								</el-button>
								<el-button size="small" type="success" round @click="clickAddType" v-else class="mt-10">
									Add Token Type
								</el-button> -->
							</el-col>
						</el-row>
						<div align="center" class="mt-60 mb-20">
							<el-button size="small" round type="primary" style="width: 200px" @click="requestTopup('ruleFormCaping')" :loading="submitreq">
								Submit Request
							</el-button>
						</div>
					</div>
				</template>
			</el-tab-pane>
			<el-tab-pane label="Billing Quota" name="billing_quota">
				<div v-loading="pendingLoading">
					<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
						<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-50">
							Total Request Quota : <br>
							<span style="font-size:32px;">{{ (totalPendingStatus) }}</span>
						</el-card>
					</el-col>
					<el-col :span="24" :md="24" :sm="24" :xs="24" v-if="totalPendingStatus!=0">
						<el-card style="height: 100%" v-for="(h, hk) in pendingRequest" :key="hk" class="mb-10 pb-30">
							<el-col :span="12" :md="12" :sm="12" :xs="12">
								<div>
									<strong style="font-size: 20px;">{{h.customerName}} ({{h.customerNumber}})</strong>
								</div>
								<div>
									Product type {{ h.productType }}
								</div>
								<div>
									<span v-if="h.topupType=='Added'">Request <strong style="color: green"> addition </strong> point</span>
									<span v-else>Request <strong style="color: red"> reduction </strong> point</span>
									<ul v-for="(dtl, hdtl) in h.detail" :key="hdtl">
										<li style="font-size: 16px">
											<div>
												<span style="font-weight: bold;">{{dtl.quota}}</span> Token <span style="font-weight: bold;">{{dtl.tokenType}}</span>
												<br>
												<span style="font-size: 12px">Quota Before Topup : {{ dtl.quota_before_topup }}</span>
												<br>
												<span style="font-size: 12px">Quota After Topup : {{ dtl.quota_after_topup }}</span>
											</div>
										</li>
									</ul>
								</div>
								<div class="mt-30 mb-20">
									<div class="mb-10" style="font-weight: bold; font-size: 14px">Request reason :</div>
									<el-input type="textarea" style="width: 300px;" disabled v-model="h.reason"></el-input>
								</div>
								<div>
									<el-tag type="warning">{{ h.topupStatus }}</el-tag>
								</div>
							</el-col>
							<el-col :span="12" :md="12" :sm="12" :xs="12">
								<!-- <div justify="right" align="right" style="font-size: 24px;">
									<strong>Topup Nominal : {{ totalBilling }}</strong>
								</div> -->
								<div class="pr-0 mt-10" style="text-align: right;">
									<el-button type="text" @click="openDocumentBilling(h)">
										<i class="el-icon-document"></i> Document Billing
									</el-button>
								</div>
								<div class="mt-0">
									<el-col :span="24" :md="24" :sm="24" :xs="24" class="pr-0 mb-20">
										<div style="text-align: right; font-size: 14px" class="mt-10">Select options for this request</div>
										<div style="text-align: right;" class="mt-10">
											<el-radio-group v-model="radioOptions[hk]" size="small">
												<el-radio-button label="Approved"></el-radio-button>
												<el-radio-button label="Rejected"></el-radio-button>
											</el-radio-group>
										</div>
									</el-col>
									<el-col :span="24" :md="24" :sm="24" :xs="24" class="pl-0" style="text-align: right;">
										<el-button size="small" :loading="loadingApproved" @click="finalSubmit(h)" type="success" style="width: 150px" round v-if="radioOptions[hk]=='Approved'">
										<!-- <el-button size="small" @click="finalSubmit(h)" type="success" style="width: 150px" round v-if="radioOptions[hk]=='Approved'"> -->
											Submit for Approved
										</el-button>
										<el-button size="small" :loading="loadingApproved" @click="finalSubmit(h)" type="danger" style="width: 150px" round v-else>
											Submit for Rejected
										</el-button>
									</el-col>
								</div>
							</el-col>
						</el-card>
					</el-col>
					<el-col v-else>
						<img src="../assets/images/empty_data.png" alt="No data image" class="img-center" />
						<div style="text-align: center;" class="mb-40">
							<h4>Oops... Data not found</h4>
						</div>
					</el-col>
				</div>
			</el-tab-pane>
			
			<!-- <el-tab-pane label="Topup Deposit" name="topup">
				<div>
					<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
						<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-50">
							Total Consumen : <br>
							<span style="font-size:32px;">{{ (total) }}</span>
						</el-card>
					</el-col>
				</div>
				<el-dialog title="Confirmation Detail" :visible.sync="dialogCheckVisible">
					<el-form :model="ruleForm" :loading="formLoading">
						<el-form-item label="Company" :label-width="formLabelWidth">
							<el-input :style="{ width: '80%'}" v-model="ruleForm.selectedCompany.customer_name" auto-complete="off" disabled></el-input>
						</el-form-item>
						<el-form-item label="Phone Number" :label-width="formLabelWidth">
							<el-input :style="{ width: '80%'}" v-model="ruleForm.selectedPhoneNumber" auto-complete="off" disabled></el-input>
						</el-form-item>
						<el-form-item label="Amount Saldo" :label-width="formLabelWidth">
							<el-input :style="{ width: '80%'}" v-model="ruleForm.num8" auto-complete="off" disabled></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogCheckVisible = false">Cancel</el-button>
						<el-button type="primary" @click="finalSubmit" :loading="btnLoading">Submit</el-button>
					</span>
				</el-dialog>
				<template>
					<div class="row">
						<el-row :gutter="30">
							<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :loading="loadingBtn">
								<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="150px">
									<el-form-item label="Company" prop="selectedCompany">
										<el-select
											:style="{ width: '100%'}"
											filterable
											v-model="ruleForm.selectedCompany" placeholder="Select Company" v-loading="loadingNumber">
											<el-option
												v-for="(c,i) in costumers" :key="i"
												:label="c.customer_name"
												:value="c">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="Phone Number" prop="selectedPhoneNumber">
										<el-select
											:style="{ width: '100%'}"
											filterable
											v-model="ruleForm.selectedPhoneNumber" placeholder="Select Number Phone" v-loading="loadingNumber">
											<el-option
												v-for="(numb,index) in number" :key="index"
												:label="numb.number"
												:value="numb.number">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="Current Saldo (IDR)" v-if="ruleForm.selectedPhoneNumber != ''">
										<el-input :style="{ width: '100%'}" v-model="dataSaldo" auto-complete="off" disabled v-loading="saldoLoading">{{saldo}}</el-input>
									</el-form-item>
									<el-form-item label="Nominal Balance" prop="num8">
										<el-input-number v-model="ruleForm.num8" controls-position="right" @change="handleChange" :min="1"></el-input-number>
									</el-form-item>
									<el-form-item>
										<el-button :loading="loadingBtn" type="success" @click="submitTopUp('ruleForm')">Top Up</el-button>
										<el-button @click="resetForm('ruleForm')">Reset</el-button>
									</el-form-item>
								</el-form>
							</el-col>
						</el-row>
					</div>
				</template>
			</el-tab-pane> -->
			<el-tab-pane label="History Finance" name="history_finance">
				<div>
					<el-col :span="24" :md="24" :sm="24" :xs="24" justify="end" >
						<el-card style="background: linear-gradient(45deg, rgb(36, 147, 147) 0%, rgba(85,85,85,1) 100%); color:#ffffff; font-weight:bold;" class="mb-50">
							Total History : <br>
							<span style="font-size:32px;">{{ (totalHistory) }}</span>
						</el-card>
					</el-col>
				</div>
				<template>
				
				<el-table :data="history" style="width: 100%" v-loading="historyLoading">
					<el-table-column prop="companyName" label="Company Name" width="130" fixed="left">
						<template slot-scope="props">
							<el-tooltip>
								<div style="width: 250px;" class="tooltip" slot="content">{{props.row.customerName}}</div>
								<p style="font-weight:bold;" v-if="props.row.customerName!=null && props.row.customerName.length >= 10">{{ props.row.customerName.substring(0, 10) }}...</p>
								<p style="font-weight:bold;" v-if="props.row.customerName!=null && props.row.customerName.length < 10">{{ props.row.customerName.substring(0, 10) }}</p>
								<p style="font-weight:bold;" v-else>-</p>
							</el-tooltip>
							<!-- <p style="font-weight:bold;">{{ props.row.customerName }}</p> -->
						</template>
					</el-table-column>

					<!-- <el-table-column prop="customerId" label="Customer Id" width="250">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ props.row.customerId }}</p>
						</template>
					</el-table-column> -->

					<el-table-column prop="customerNumber" label="Company Number" width="140">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ props.row.customerNumber }}</p>
						</template>
					</el-table-column>

					<el-table-column prop="createdAt" label="Request Date" width="180">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ formatDate(props.row.createdAt, "DD/MM/YY HH:mm:ss") }}</p>
						</template>
					</el-table-column>

					<el-table-column label="Documents" width="180">
						<template slot-scope="scope">
							<el-button v-if="scope.row.topupStatus == 'Approved'" @click="openDocumentBilling(scope.row)" type="text">Download</el-button>
							<div style="padding-left:30px;" v-else>-</div>
						</template>
					</el-table-column>

					<el-table-column prop="type" label="Product Type" width="200">
						<template slot-scope="props">
							<p style="font-weight:bold;">{{ props.row.productType }}</p>
						</template>
					</el-table-column>
					
					<el-table-column prop="tokenType" label="Token Type" width="155">
						<template slot-scope="props">
							<span style="font-weight:bold;" v-for="(a, k) in props.row.detail" :key="k">
								<el-tag v-if="props.row.detail.length > 0 || props.row.detail" style="margin: 2px">{{ a.tokenType }}</el-tag>
								<p style="font-weight:bold;" v-else>-</p>
							</span>
							<!-- <p style="font-weight:bold;" v-if="props.row.tokenType!=null">{{ props.row.tokenType }}</p> -->
						</template>
					</el-table-column>
					<el-table-column prop="topupType" label="Topup Type" width="120">
						<template slot-scope="props">
							<p style="font-weight:bold;" v-if="props.row.topupType!=null">{{ props.row.topupType }}</p>
							<p style="font-weight:bold;" v-else>-</p>
						</template>
					</el-table-column>
					<el-table-column prop="responsible" label="Responsible" width="150">
						<template slot-scope="props">
							<span v-if="props.row.responsible!=''">{{ props.row.responsible }}</span>
							<span v-else-if="!props.row.responsible">-</span>
							<span v-else>-</span>
							<!-- <p style="font-weight:bold;">{{ formatDate(props.row.createdAt, "DD/MM/YY HH:mm:ss") }}</p> -->
						</template>
					</el-table-column>
					<el-table-column prop="reason" label="Note" width="150">
						<template slot-scope="props">
							<!-- <p style="font-weight:bold;">{{ props.row.reason }}</p> -->
							<el-tooltip>
								<div style="width: 250px;" class="tooltip" slot="content">{{props.row.reason}}</div>
								<p style="font-weight:bold;" v-if="props.row.reason!=null && props.row.reason.length >= 10">{{ props.row.reason.substring(0, 10) }}...</p>
								<p style="font-weight:bold;" v-if="props.row.reason!=null && props.row.reason.length < 10">{{ props.row.reason.substring(0, 10) }}</p>
								<p style="font-weight:bold;" v-else>-</p>
							</el-tooltip>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="nominal" label="Topup Quantity" width="250">
						<template slot-scope="props">
							<span style="font-weight:bold;" v-for="(a, k) in props.row.detail" :key="k">
								<el-tag style="margin:5px;">{{ a.tokenType }} : {{ a.quota }}</el-tag>
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="topupNominal" label="Topup Nominal" width="250">
						<template slot-scope="props">
							<span style="font-weight:bold;" v-for="(a, k) in props.row.detail" :key="k">
								<el-tag style="margin:5px;">{{ a.quota }}</el-tag>
							</span>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="documents" label="Documents" width="120" fixed="right">
						<template slot-scope="props">
							<el-button type="text" @click="openDocumentBilling(props.row)">View Document</el-button>
						</template>
					</el-table-column> -->
					<el-table-column prop="topupStatus" label="Status" width="100" fixed="right">
						<template slot-scope="props">
							<!-- <span style="font-weight:bold;" v-for="(a, k) in props.row.detail" :key="k"> -->
							<el-tag type="warning" v-if="props.row.topupStatus=='Pending Request'">{{ props.row.topupStatus }}</el-tag>
							<el-tag type="success" v-if="props.row.topupStatus=='Approved'">{{ props.row.topupStatus }}</el-tag>
							<el-tag type="danger" v-if="props.row.topupStatus=='Rejected'">{{ props.row.topupStatus }}</el-tag>
							<!-- </span> -->
						</template>
					</el-table-column>
					
					<!-- <el-table-column fixed="right" label="#" width="190">
						<template slot-scope="scope">
							<el-button @click="detailProduct(scope.row._id)" type="primary" size="small">
								<i class="mdi mdi-eye"></i> 
							</el-button>
							<el-button @click="deleteProduct(scope.row._id)" type="danger" size="small" :loading="loadingBtnDelete">
								<i class="mdi mdi-delete-forever"></i>
							</el-button>
						</template>
					</el-table-column> -->
				</el-table>
			</template>
			</el-tab-pane>
			<el-tab-pane label="TAX" name="tax_fee">
				<el-form status-icon ref="ruleForm" label-width="120px" class="demo-ruleForm">
					<h4>Setting Adding Quota</h4>
					<el-form-item label="Service Fee (%)" prop="service_fee">
						<el-input type="number" v-model="settingForm.service_fee_add" style="width: 220px"></el-input>
					</el-form-item>
					<el-form-item label="PPN (%)" prop="tax">
						<el-input type="number" v-model="settingForm.service_tax_add" style="width: 220px"></el-input>
					</el-form-item>
					<el-form-item label="PPH 23 (%)" prop="tax">
						<el-input type="number" v-model="settingForm.pph_add" style="width: 220px"></el-input>
					</el-form-item>
					<h4 style="color:red">Setting Minus Quota</h4>
					<el-form-item label="Service Fee (%)" prop="service_fee">
						<el-input type="number" v-model="settingForm.service_fee_minus" style="width: 220px"></el-input>
					</el-form-item>
					<el-form-item label="PPN (%)" prop="tax">
						<el-input type="number" v-model="settingForm.service_tax_minus" style="width: 220px"></el-input>
					</el-form-item>
					<el-form-item label="PPH 23 (%)" prop="tax">
						<el-input type="number" v-model="settingForm.pph_min" style="width: 220px"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitSetting" :loading="loadingAddSetting">Save</el-button>
						<el-button>Reset</el-button>
					</el-form-item>
				</el-form>
			</el-tab-pane>
			<el-dialog title="Document Billing" :visible.sync="dialogDocumentBilling" v-loading="loadingLoadBilling" id="html-2-pdfwrapper">
				<el-col :span="24" :md="24" :sm="24" :xs="24" class="mb-10">
					<div class="title" align="center">
						<h2>Invoice {{detailTopupData.customerName}}</h2>
					</div>
				</el-col>
				<el-row class="mt-10">
					<el-col :span="12" :md="12" :sm="12" :xs="12">
						<div>
							Request Date : {{ formatDate(detailTopupData.createdAt, "DD/MM/YY HH:mm:ss") }}
						</div>
						<div>
							Whatsapp Business : {{detailTopupData.customerNumber}}
						</div>
						<div>
							Product Name : WhatsApp Conversation
						</div>
						<div>
							Product Type : {{detailTopupData.productType}}
						</div>
						<div>
							Topup Type : {{detailTopupData.topupType}}
						</div>
					</el-col>
					<el-col :span="12" :md="12" :sm="12" :xs="12">
						<div class="invoice bg-white black-text">
							<div class="invoice-top">
								<div class="logo">
									<el-row :gutter="10" style="float:right">
										<el-col style="padding-right: 10px;" :xs="20" :sm="12" :md="4" :lg="6" :xl="1"><div class="grid-content bg-purple">
											<img src="@/assets/images/logo-cropped.png" alt="logo" height="60px;"></div>
										</el-col>
										<el-col style="padding-left: 20px;" :xs="4" :sm="12" :md="20" :lg="18" :xl="23"><div class="grid-content bg-purple-light">
											<strong>DAM Corp.</strong><br>
											deposit@damcorp.id<br>(021) 30487010
											</div>
										</el-col>
									<!-- <el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11"><div class="grid-content bg-purple"></div></el-col>
									<el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="1"><div class="grid-content bg-purple-light"></div></el-col> -->
									</el-row>
								</div>
							</div>
						</div>
					</el-col>
					<!-- <el-col class="mt-20">
						Note<br>
						<el-input type="textarea" disabled v-model="detailTopupData.reason" placeholder="Note" class="mt-10"></el-input>
					</el-col> -->
					<!-- <div>
							<h2>{{ totalBilling }}</h2>
						</div> -->
					<el-col class="mt-20">
						<h2 class="mb-20">Rincian</h2>
						<table class="css-serial" id="inv">
							<tr>
								<th>No</th>
								<th>Token Type</th>
								<th>Quantity</th>
								<th>Price</th>
								<th>Discount</th>
								<th>Sub Total</th>
							</tr>
							<tr v-for="(dt, kt) in detailTopupData.detail" :key="kt">
								<td>{{kt + 1}}</td>
								<td>{{ dt.tokenType }}</td>
								<td>{{ dt.quota }}</td>
								<td v-for="(p,kp) in prefix" :key="kp">
									<span v-if="dt.tokenType=='CBP'">{{ formatPrice(p.price_cbp)}}</span>
									<span v-if="dt.tokenType=='UI'">{{formatPrice(p.price_ui)}}</span>
									<span v-if="dt.tokenType=='BI'">{{formatPrice(p.price_bi)}}</span>
								</td>
								<td>{{ dt.discount }}</td>
								<td v-for="(p,k) in prefix" :key="k" style="text-align: right;">
									<span v-if="dt.tokenType=='CBP'">{{ formatPrice(dt.quota * (p.price_cbp-dt.discount)) }}</span>
									<span v-if="dt.tokenType=='UI'">{{ formatPrice(dt.quota * (p.price_ui-dt.discount)) }}</span>
									<span v-if="dt.tokenType=='BI'">{{ formatPrice(dt.quota * (p.price_bi-dt.discount)) }}</span>
								</td>
							</tr>
						</table>
						<table class="css-serial" id="inv2">
							<tr style="background-color: #333333;">
								<th colspan="5" style="text-align: right; background-color: #C6C6C6; color: black; padding-right: 20px">Service fee</th>
								<th style="background-color: #C6C6C6; color: black; text-align: right;">{{ detailTopupData.topupType == 'Added' ? formatPrice(settingForm.service_fee_add) : formatPrice(settingForm.service_fee_minus) }}</th>
							</tr>
							<tr>
								<th colspan="5" style="text-align: right; background-color: #C6C6C6; color: black; padding-right: 20px">PPN</th>
								<th style="background-color: #C6C6C6; color: black; text-align: right;">{{ detailTopupData.topupType == 'Added' ? formatPrice(settingForm.service_tax_add) : formatPrice(settingForm.service_tax_minus) }}</th>
							</tr>
							<tr>
								<th colspan="5" style="text-align: right; background-color: #C6C6C6; color: black; padding-right: 20px">PPH 23</th>
								<th style="background-color: #C6C6C6; color: red; text-align: right;">{{ detailTopupData.topupType == 'Added' ? formatPrice(settingForm.pph_add) : formatPrice(settingForm.pph_min) }}</th>
							</tr>
							<tr>
								<th colspan="5" style="text-align: right; padding-right: 20px">Total</th>
								<th>
									<h3 style="text-align: right;">{{ totalBilling }}</h3>
								</th>
							</tr>
						</table>
					</el-col>
					<el-col class="mt-20">
						Note<br>
						<el-input type="textarea" disabled v-model="detailTopupData.reason" placeholder="Note" class="mt-10"></el-input>
						<div align="right">
							<!-- <el-button size="small" class="mt-10" @click="exportPDF" @click="print" :loading="loadingPrint" round type="primary">Download PDF</el-button> -->
							<!-- <el-button size="small" class="mt-10" @click="print" :loading="loadingPrint" round type="primary">Download PDF</el-button> -->
							<el-button size="small" class="mt-10" @click="pdfCreate" :loading="loadingPrint" round type="primary">Download PDF</el-button>
						</div>
					</el-col>
				</el-row>
				<!--End InvoiceTop-->
			</el-dialog>
		</el-tabs>
    </el-card>
	<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
		DAM Corp.
	</el-card>
	</div>
</template>

<script>
import config from '@/config'
import axios from 'axios'
import api from '@/networkClient'
const moment = require('moment')
import store from '@/store'
import Template from './consumen/Template.vue'
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"
import VueHtml2pdf from 'vue-html2pdf'
import imgSrc from '../assets/images/logo_dkd.png'

export default {
  components: { Template },
	name: 'Finance',
    data() {
        return {
			loadingPrint: false,
			submitreq: false,
			loadingLoadBilling: false,
			loadingAddSetting: false,
			loadingSetting: false,
			cusId: "",
			user: {
				name: store.getters.userName,
				company: store.getters.companyName
			},
			products_name: [
				{
					name:'Whatsapp Conversation'
				},{
					name:'Whatsapp Notification'
				}
			],
			products_notif: [
				{
					name:'notification_caping_plafon'
				},{
					name:'notification_caping'
				}
			],
			setting: [],
			settingForm: {
				service_fee_add: 0,
                service_tax_add: 0,
				pph_add: 0,
                service_fee_minus: 0,
                service_tax_minus: 0,
				pph_min: 0
			},
			product: [ { product: [] } ],
			// products_notif: [{name:'cbp_caping'},{name:'cbp_hybrid'}],
			token_type: [{
				name:'CBP',
				value: 'CBP',
				disabled: false
			},{
				name:'UI',
				value: 'UI',
				disabled: false
			}, {
				name: 'BI',
				value: 'BI',
				disabled: false
			}],
			radio: 'Added',
			dialogCheckVisible: false,
			dialogCheckVisibleCaping: false,
			dialogDocumentBilling: false,
			formLabelWidth: '300px',
			formLoading: false,
			loadingDetail: false,
			btnLoading: false,
			loadingBtn: false,
			saldoLoading: false,
			pendingLoading: false,
			loadingNumberCaping: false,
			loadingNumber: false,
			loadingPrefix: false,
			loadingApproved: false,
			loadingRejected: false,
			prefix:[],
			detailTopupData: {},
			ruleForm: {
				selectedPhoneNumber: "",
				selectedCompany: "",
				num8: ""
			},
			ruleFormCaping: {
				selectedProductName: "Whatsapp Conversation",
				selectedProduct: "notification_caping_plafon",
				selectedCompany: "",
				selectedPhoneNumber: "",
				topuptype: "Added",
				reason: "",
				detail: [{
					tokenType: "CBP",
					quota_before_topup: 0,
					quota: 0,
					quota_after_topup: 0,
					discount: 0
				},{
					tokenType: "UI",
					quota_before_topup: 0,
					quota: 0,
					quota_after_topup: 0,
					discount: 0
				},{
					tokenType: "BI",
					quota_before_topup: 0,
					quota: 0,
					quota_after_topup: 0,
					discount: 0
				}],
				total_nominal: 0
			},
			rules: {
				selectedProduct: [
					 { required: true, message: 'Please select Product Notif', trigger: 'change' }
				],
				selectedPhoneNumber: [
					 { required: true, message: 'Please select Phone Number', trigger: 'change' }
				],
				selectedCompany: [
					{ required: true, message: 'Please select Company', trigger: 'change' }
				],
				num8: [
					{ required: true, message: 'Please input nominal', trigger: 'blur' },
				],
				// tokenType: [
				// 		{ required: true, message: 'Please select Token Type', trigger: 'change' }
				// ],
				reason: [
					{ required: true, message: 'Please enter reason', trigger: 'change' }
				],
				topuptype: [
					{ required: true, message: 'Please select Topup Type', trigger: 'change' }
				],
				// quota: [
				// 	{ required: true, message: 'Please input quota', trigger: 'blur' },
				// ]
			},
			costumers : [],
			costumersCaping : [],
			total: 0,
			totalCaping: 0,
			dataSaldo: '',
			dataQuota: 0,
			dataQuotaUI: 0,
			dataQuotaBI: 0,
			dataCapingQuota: '',
			historyLoading: false,
			history: [],
			totalHistory: 0,
			pendingRequest: [],
			totalPendingStatus: 0,
			totality: [],
			priceCbp: 0,
			priceUi: 0,
			priceBi: 0,
			totalCbp: 0,
			totalUi: 0,
			totalBi: 0,
			totalBilling: 0,
			totalPrice: 0,
			discountCBP: 0,
			discountUI: 0,
			discountBI: 0,
			activeTab: "capping_quota",
			radioOptions: [],
			setting: []
        }
    },
	// components: {
	// 	VueHtml2pdf
	// },
    methods: {
		maintenance () {
			alert("Under maintenance")
		},
		generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
		subTotal(items) {
			return items.reduce((acc, ele) => {
				return acc + parseInt(ele.bfloorArea);
			}, 0);
		},
		async beforeDownload ({ html2pdf, options, pdfContent }) {
            await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)
                    pdf.setFontSize(10)
                    pdf.setTextColor(150)
                    pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                } 
            }).save()
        },
		submitSetting(){
			this.loadingAddSetting = true
			api({
				method: "post",
				url: config.baseApi+"finance/setting",
				data: {
					service_fee_add: this.settingForm.service_fee_add,
					service_tax_add: this.settingForm.service_tax_add,
					pph_add: this.settingForm.pph_add,
					service_fee_minus: this.settingForm.service_fee_minus,
					service_tax_minus: this.settingForm.service_tax_minus,
					pph_min: this.settingForm.pph_min
				}
			}).then(response => {
				console.log("response add setting",response)
				this.loadingAddSetting = false
				this.settingForm.service_fee_add = 0
				this.settingForm.service_tax_add = 0
				this.settingForm.pph_add = 0
				this.settingForm.service_fee_minus = 0
				this.settingForm.service_tax_minus = 0
				this.settingForm.pph_min = 0
				this.$swal(this.$t('success'), "Data setting tax & fee berhasil disimpan ", "success")
				this.getSetting()
			}).catch(error => {
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
			})
		},
		getSetting(){
			this.loadingSetting = true
			api({
				method: "get",
				url: config.baseApi+"finance/setting"
			}).then(response => {
				console.log("response get setting",response)
				this.setting = response.data.data
				console.log("setting",this.setting)
				// if(this.detailTopupData.topupType == 'Added'){
					this.settingForm.service_fee_add = this.setting[0].service_fee_add
					this.settingForm.service_tax_add = this.setting[0].service_tax_add
					this.settingForm.pph_add = this.setting[0].pph_add
				// }
				// if(this.detailTopupData.topupType == 'Minus'){
					this.settingForm.service_fee_minus = this.setting[0].service_fee_minus
					this.settingForm.service_tax_minus = this.setting[0].service_tax_minus
					this.settingForm.pph_min = this.setting[0].pph_min
				// }
			}).catch(error => {
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
			})
			this.loadingSetting = false
		},
		async print(){
            this.loadingPrint = true
            let elementHTML = document.getElementById('html-2-pdfwrapper')
            this.$html2canvas(elementHTML, {ignoreElements: function (el) {return el.tagName.toLowerCase() === 'button'},
            scale: 0.65})
            .then(canvas => {
				var pdf = new jsPDF('p', 'pt', 'letter');

				var pageHeight = 1280;
				var pageWidth = 920;
				for (var i = 0; i <= elementHTML.clientHeight / pageHeight; i++) {
					var srcImg = canvas;
					var sX = 0;
					var sY = pageHeight * i; // start 1 pageHeight down for every new page
					var sWidth = pageWidth;
					var sHeight = pageHeight;
					var dX = 0;
					var dY = 0;
					var dWidth = pageWidth;
					var dHeight = pageHeight;

					window.onePageCanvas = document.createElement("canvas");
					onePageCanvas.setAttribute('width', pageWidth);
					onePageCanvas.setAttribute('height', pageHeight);
					var ctx = onePageCanvas.getContext('2d');
					ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);

					var canvasDataURL = onePageCanvas.toDataURL("image/png", 2.0);
					var width = onePageCanvas.width;
					var height = onePageCanvas.clientHeight;

					// if (i == 0) {
					// 	pdf.text(`${this.consumen_name}`, 30, 60)
					// 	pdf.text(`${moment(this.selectedMonth).format("MMM YYYY")}`, 400, 60)
					// }

					// if (i > 0) {pdf.addPage(612, 864)} // 8.5" x 12" in pts (inches*72)

					// pdf.setPage(i + 1); // now we declare that we're working on that page
					pdf.addImage(canvasDataURL, 'PNG', 25, 20, (width * .62), (height * .62)); // add content to the page
				}

				pdf.autoPrint();

				const hiddFrame = document.createElement('iframe');
					hiddFrame.style.position = 'fixed';
					// "visibility: hidden" would trigger safety rules in some browsers like safari，
					// in which the iframe display in a pretty small size instead of hidden.
					hiddFrame.style.width = '1px';
					hiddFrame.style.height = '1px';
					hiddFrame.style.opacity = '0.01';
					const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
					if (isSafari) {
						// fallback in safari
						hiddFrame.onload = () => {
							try {
							hiddFrame.contentWindow.document.execCommand('print', false, null);
							} catch (e) {
							hiddFrame.contentWindow.print();
							}
						};
					}
					hiddFrame.src = pdf.output('bloburl');
				document.body.appendChild(hiddFrame);
				// Save the PDF
				// pdf.save('document.pdf');   //or whatever you want to execute
				
				this.loadingPrint = false
			});
        },
		exportPDF(v) {
			console.log("V di pdf",v)
			console.log("detail data untuk pdf",this.detailTopupData)
			var dtl = this.detailTopupData.detail

			// this.detailTopupData.detail.forEach(dtl => {
			if(dtl[0]){
				var tknType = dtl[0].tokenType
				var tknType = dtl[1].tokenType
				var tknType = dtl[2].tokenType

				var productNames = this.detailTopupData.productType == "notification_caping_plafon" ? "Notification Caping Plafon" : "Notification Caping"
				if(tknType=="CBP"){
					var quanty = dtl[0].quota
					console.log("quanty cbp",quanty)
					var price = this.priceCbp
					var discount = dtl[0].discount
					var subTotal = quanty*(price-discount)
				}
				if(tknType=="UI"){
					var quanty = dtl[1].quota
					console.log("quanty ui",quanty)
					var price = this.priceUi
					var discount = dtl[1].discount
					var subTotal = quanty*(price-discount)
				}
				if(tknType=="BI"){
					var quanty = dtl[2].quota
					console.log("quanty bi",quanty)
					var price = this.priceBi
					var discount = dtl[2].discount
					var subTotal = quanty*(price-discount)
				}
			}
			// var tknType = this.detailTopupData.detail[0].tokenType
			// var tknType2 = this.detailTopupData.detail[1].tokenType
			// var tknType3 = this.detailTopupData.detail[2].tokenType
			// var productNames = this.detailTopupData.productType == "notification_caping_plafon" ? "Notification Caping Plafon" : "-"
			// if(tknType=="CBP"){
			// 	var quanty = this.detailTopupData.detail[0].quota
			// 	var price = this.priceCbp
			// 	var subTotal = quanty*price
			// }
			// if(tknType2=="UI"){
			// 	var quanty2 = this.detailTopupData.detail[1].quota
			// 	var price2 = this.priceUi
			// 	var subTotal2 = quanty2*price2
			// }
			// if(tknType3=="BI"){
			// 	var quanty3 = this.detailTopupData.detail[2].quota
			// 	var price3 = this.priceBi
			// 	var subTotal3 = quanty3*price3
			// }

			let pdfName = 'test'; 
			var doc = new jsPDF();
			// doc.setFontSize(18)
			// doc.text('With content', 14, 22)
			doc.setFontSize(11)
			doc.setTextColor(100)
			// var strArr = doc.splitTextToSize("A longer title that might be split", 50)
			// doc.autoTable({
			// 	body: [
			// 		[{ content: 'Text', colSpan: 2, rowSpan: 2, styles: { halign: 'center' } }],
			// 	],
			// })
			// doc.text("Invoice", 10, 20);
			doc.text("INVOICE", 10, 10);
			// doc.line(25, 30, 65, 30);
			doc.text(this.detailTopupData.customerName+" ("+this.detailTopupData.customerNumber+")", 10, 20);
			doc.text("Request Date : "+moment(this.detailTopupData.createdAt).format("DD-MM-YYYY hh:mm:ss"), 10, 25);
			doc.text("Product Name : Whatsapp Conversation", 10, 30);
			doc.text("Product Type : "+productNames, 10, 35);
			doc.text("Topup Type : "+this.detailTopupData.topupType, 10, 40);
			doc.text("Reason : "+this.detailTopupData.reason, 10, 45)
			doc.text("Total : "+this.formatPrice(subTotal), 10, 55)
			// doc.setLineDash([7, 3, 1, 3], 54);
			// doc.line(54, 54, 54, 54)
			// doc.text(strArr, 10, 60);
			doc.text("Rincian", 10, 65);
			doc.autoTable({
				startY: 70,
	// 			columnStyles: {
    //   id: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' },
    // },
				columnStyles: { tokenType: { halign: 'left' }, fontStyle: 'bold' }, // European countries centered
				body: [
					{ tokenType: tknType, quantity: quanty, price: this.formatPrice(price), discount: discount, subTotal: this.formatPrice(subTotal) },
					{ tokenType: tknType, quantity: quanty, price: this.formatPrice(price), discount: discount, subTotal: this.formatPrice(subTotal) },
					{ tokenType: tknType, quantity: quanty, price: this.formatPrice(price), discount: discount, subTotal: this.formatPrice(subTotal) }
					// { tokenType: tknType2, quantity: quanty2, price: this.formatPrice(price2), subTotal: this.formatPrice(subTotal2) },
					// { tokenType: tknType3, quantity: quanty3, price: this.formatPrice(price3), subTotal: this.formatPrice(subTotal3) },
					// { total: subTotal+subTotal2+subTotal3 }
				],
				columns: [
					{ header: 'Token Type', dataKey: 'tokenType' },
					{ header: 'Quantity', dataKey: 'quantity' },
					{ header: 'Price', dataKey: 'price' },
					{ header: 'Discount', dataKey: 'discount' },
					{ header: 'Sub Total', dataKey: 'subTotal' },
					// { header: 'Total', dataKey: 'total' },
				],
			})
			doc.save(pdfName + '.pdf');
			// });

			

			// let data =[];
			// let obj = {
			// 	customerNumber:this.detailTopupData.customerNumber,
			// };
			// console.log("obj pdf",obj.customerNumber)
			// data.push(obj);
			// data.forEach(element => {
			// 	var customerNum = element.customerNumber
			// 	console.log("number cust nya",customerNum)
			// 	console.log("data nyaaa...",data)
			// 	let header = ["TokenType"];
			// 	// let headerConfig = header.map(key=>({ 
			// 	// 	'name': key,
			// 	// 	'prompt': key,
			// 	// 	'width':85,
			// 	// 	'align':'center',
			// 	// 	'padding':0
			// 	// }));
			// 	const pdf = new jsPDF();
			// 	pdf.setFont("calibri");
			// 	pdf.setFontSize(14);
			// 	pdf.text("Invoice", 10, 10);
			// 	pdf.table(10, 20, customerNum, header);
			// 	try {
			// 		pdf.save(`${this.detailTopupData.customerNumber}.pdf`);
			// 	} catch (error) {
			// 		console.log(error);
			// 	}
			// });
			
			// var vm = this
			// var columns = [
			// 	{title: "Token Type", dataKey: "tokenType"}
			// ];

			// this.detailTopupData.forEach(element => {
				// var doc = new jsPDF();
				// doc.text("Invoice", 10, 10)
				// autoTable(doc, {
				// 	head: [['Token Type', 'Quantity', 'Price', 'Sub Total']],
				// 	body: this.detailTopupData.customerNumber
				// });
				// doc.save("Billing Topup.pdf");
			// });


			// const htmlContent = this.$refs.content.innerHTML
			
			// doc.html(htmlContent.innerHTML, {'x': 15,
			// 	'y': 15,
			// 	'width': 200,
			// 	'elementHandlers': htmlContent})

			// doc.text("Hello world!", 1, 1);
		},
		pdfCreate(){
			const doc = new jsPDF()
			var totalPagesExp = '1'
			var img = new Image()
			img.src = imgSrc
			autoTable(doc, {
				didDrawPage: function (data) {
				// Header
				doc.setFontSize(20)
				doc.setTextColor(40)
				if (img) {
					doc.addImage(img, 'PNG', data.settings.margin.left, 15, 30, 15)
				}
				doc.setFont("helvetica", "bold");
				doc.text('PT Dam Korporindo Digital', data.settings.margin.left + 35, 25)

				// Footer
				// var str = 'Page ' + doc.internal.getNumberOfPages()
				// Total page number plugin only available in jspdf v1.0+
				// if (typeof doc.putTotalPages === 'function') {
				// 	str = str + ' of ' + totalPagesExp
				// }
				// doc.setFontSize(10)

				// jsPDF 1.4+ uses getWidth, <1.4 uses .width
				// var pageSize = doc.internal.pageSize
				// var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
				// doc.text(str, data.settings.margin.left, pageHeight - 10)
				},
				margin: { top: 30 },
				// styles: { fillColor: null, fontSize: 12 }
			})
			
			doc.setFont("helvetica", "bold");
			doc.text("INVOICE", 105, 50, null, null, "center");
			doc.setLineWidth(0.5);
			doc.line(120, 51, 90, 51);
			doc.setFont("helvetica", "normal");
			doc.setFontSize(12);
			let nomor = `No: ${this.pendingRequest.findIndex(el => el._id == this.detailTopupData._id) != -1 ? (this.pendingRequest.findIndex(el => el._id == this.detailTopupData._id) + 1) : (this.history.findIndex(el => el._id == this.detailTopupData._id) + 1)}_DKD/${this.detailTopupData.customerNumber}/${moment(this.detailTopupData.createdAt).format("DD")}/${this.mapingRomawi(this.detailTopupData.createdAt)}/${moment(this.detailTopupData.createdAt).format("YYYY")}`
			doc.text(nomor, 105, 55, null, null, "center");

			doc.setFont("helvetica", "italic");
			doc.text("Billed to :", 15, 70);
			doc.setFont("helvetica", "normal");
			doc.text(`${this.detailTopupData.customerName}`, 15, 75);

			doc.setFont("helvetica", "italic");
			doc.text("Attn. Finance Departement", 15, 90);
			doc.setFont("helvetica", "normal");
			doc.text(`Jakarta, ${moment().format("DD MMMM YYYY")}`, 150, 90);

			let body1 = []

			autoTable(doc, {
				html: '#inv',
				startY: doc.lastAutoTable.finalY + 67,
				columnStyles: { 5: { cellWidth: 40 } },
				theme: 'grid',
				styles: { fontSize: 12 }
			})

			doc.setFont("helvetica", "bold");
			doc.text(`Note:`, 15, 143);
			// autoTable(doc, { html: '#inv', styles: { fillColor: null, fontSize: 12, fontStyle: 'bold', lineWidth: 1 } })
			// Or use javascript directly:
			autoTable(doc, {
				body: [
					[{ content: this.detailTopupData.reason, colSpan: 5, rowSpan: 2, styles: { halign: 'left', minCellHeight: 40,  fontSize: 12 } }],
				],
				startY: doc.lastAutoTable.finalY + 15,
				tableWidth: 85,
				theme: 'grid'
			})

			autoTable(doc, {
				html: '#inv2',
				columnStyles: { 0: { cellWidth: 35 } },
				startY: doc.lastAutoTable.finalY - 30,
				tableWidth: 75,
				margin: {left: 121},
				theme: 'grid',
				styles: {fontSize: 12 },
				willDrawCell: function (data) {
					// console.log('data', data.row);
					if (data.row.index == 2) {
						// console.log('data raw', data.cell);
						if (data.cell.width >= 40) {
							doc.setTextColor(231, 76, 60) // Red
						}
					}
				},
			})

			doc.save('Invoice-Finance-Topup.pdf')
		},
		mapingRomawi(date){
			let month = parseInt(moment(date).format('M'))
			let lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},
				roman = '',
				i;
			for ( i in lookup ) {
				while ( month >= lookup[i] ) {
				roman += i;
				month -= lookup[i];
				}
			}
			return roman;
		},
		disabledOption(){
			// if(this.token_type[0]=="CBP"){
			if(this.ruleFormCaping.detail.length==0 || this.ruleFormCaping.detail[0].tokenType==""){
				if(this.clickAddType){
					this.token_type[0].disabled=false
					this.token_type[1].disabled=false
					this.token_type[2].disabled=false
				}
			}
			if(this.ruleFormCaping.detail[0].tokenType=="CBP" && this.clickAddType){
				this.token_type[0].disabled=true
				this.token_type[1].disabled=false
				this.token_type[2].disabled=false
			} 
			if(this.ruleFormCaping.detail[0].tokenType=="CBP" && this.ruleFormCaping.detail[1].tokenType=="UI" && this.clickAddType){
				this.token_type[0].disabled=true
				this.token_type[1].disabled=true
				this.token_type[2].disabled=false
			}
			if(this.ruleFormCaping.detail[0].tokenType=="CBP" && this.ruleFormCaping.detail[1].tokenType=="BI" && this.clickAddType){
				this.token_type[0].disabled=true
				this.token_type[1].disabled=false
				this.token_type[2].disabled=true
			}

			else if(this.ruleFormCaping.detail[0].tokenType=="UI" && this.clickAddType){
				this.token_type[0].disabled=false
				this.token_type[1].disabled=true
				this.token_type[2].disabled=false
			} 
			if(this.ruleFormCaping.detail[0].tokenType=="UI" && this.ruleFormCaping.detail[1].tokenType=="CBP" && this.clickAddType){
				this.token_type[0].disabled=true
				this.token_type[1].disabled=true
				this.token_type[2].disabled=false
			}
			if(this.ruleFormCaping.detail[0].tokenType=="UI" && this.ruleFormCaping.detail[1].tokenType=="BI" && this.clickAddType){
				this.token_type[0].disabled=false
				this.token_type[1].disabled=true
				this.token_type[2].disabled=true
			}

			else if(this.ruleFormCaping.detail[0].tokenType=="BI" && this.clickAddType){
				this.token_type[0].disabled=false
				this.token_type[1].disabled=false
				this.token_type[2].disabled=true
			} 
			if(this.ruleFormCaping.detail[0].tokenType=="BI" && this.ruleFormCaping.detail[1].tokenType=="CBP" && this.clickAddType){
				this.token_type[0].disabled=true
				this.token_type[1].disabled=false
				this.token_type[2].disabled=true
			}
			if(this.ruleFormCaping.detail[0].tokenType=="BI" && this.ruleFormCaping.detail[1].tokenType=="UI" && this.clickAddType){
				this.token_type[0].disabled=false
				this.token_type[1].disabled=true
				this.token_type[2].disabled=true
			}



			// else if(this.deleteDataType && this.ruleFormCaping.detail[0].tokenType=="CBP"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=true
			// 	this.token_type[2].disabled=true
			// } 
			// if(this.deleteDataType && this.ruleFormCaping.detail[0].tokenType=="CBP" && this.ruleFormCaping.detail[1].tokenType=="UI"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=true
			// }
			// if(this.deleteDataType && this.ruleFormCaping.detail[0].tokenType=="CBP" && this.ruleFormCaping.detail[1].tokenType=="BI"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=true
			// 	this.token_type[2].disabled=false
			// }

			// else if(this.deleteDataType && this.ruleFormCaping.detail[0].tokenType=="UI"){
			// 	this.token_type[0].disabled=true
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=true
			// } 
			// if(this.deleteDataType && this.ruleFormCaping.detail[0].tokenType=="UI" && this.ruleFormCaping.detail[1].tokenType=="CBP"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=true
			// }
			// if(this.deleteDataType && this.ruleFormCaping.detail[0].tokenType=="UI" && this.ruleFormCaping.detail[1].tokenType=="BI"){
			// 	this.token_type[0].disabled=true
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=false
			// }

			// else if(this.deleteDataType && this.ruleFormCaping.detail[0].tokenType=="BI"){
			// 	this.token_type[0].disabled=true
			// 	this.token_type[1].disabled=true
			// 	this.token_type[2].disabled=false
			// } 
			// if(this.deleteDataType && this.ruleFormCaping.detail[0].tokenType=="BI" && this.ruleFormCaping.detail[1].tokenType=="CBP"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=true
			// 	this.token_type[2].disabled=false
			// }
			// if(this.deleteDataType && this.ruleFormCaping.detail[0].tokenType=="BI" && this.ruleFormCaping.detail[1].tokenType=="UI"){
			// 	this.token_type[0].disabled=true
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=false
			// }
			// if(this.ruleFormCaping.detail[0].tokenType=="CBP"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=true
			// 	this.token_type[2].disabled=false
			// }
			// else if(this.ruleFormCaping.detail[0].tokenType=="UI"){
				// this.token_type[0].disabled=false
				// this.token_type[1].disabled=true
				// this.token_type[2].disabled=false
			// }
			// else if(this.ruleFormCaping.detail[0].tokenType=="BI"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=true
			// }

			// if(this.ruleFormCaping.detail[1].tokenType=="CBP"){
			// 	this.token_type[0].disabled=true
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=false
			// }
			// else if(this.ruleFormCaping.detail[1].tokenType=="UI"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=true
			// 	this.token_type[2].disabled=false
			// }
			// else if(this.ruleFormCaping.detail[1].tokenType=="BI"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=true
			// }

			// if(this.ruleFormCaping.detail[2].tokenType=="CBP"){
			// 	this.token_type[0].disabled=true
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=false
			// }
			// else if(this.ruleFormCaping.detail[2].tokenType=="UI"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=true
			// 	this.token_type[2].disabled=false
			// }
			// else if(this.ruleFormCaping.detail[2].tokenType=="BI"){
			// 	this.token_type[0].disabled=false
			// 	this.token_type[1].disabled=false
			// 	this.token_type[2].disabled=true
			// }
			// }
			// if(this.token_type)
			// console.log('a adalah',a)
		},
		tabClick(tab){
			if(tab.name == "topup"){
				this.resetForm()
				this.loadCompany()
			} else if(tab.name == "capping_quota"){
				this.resetForm()
				this.loadCompanyCaping()
			} else if(tab.name == "history_finance"){
				this.resetForm()
				this.getHistory()
			} else if(tab.name == "billing_quota"){
				this.resetForm()
				// this.totalBill()
				this.getHistory()
				this.getPendingTopup()
			} else if(tab.name == "tax_fee"){
				// this.totalBill()
				this.getSetting()
			}
		},
		formatDate(val, format){
            return moment(val).format(format)
		},
		detailConsumenProduct(){
            this.loadingConsumenProduct = true
            // let custId = 
            api({
                url: config.baseApi + 'consumen/' + this.cusId + "/product",
                method: 'get'
            })
            .then(res => {
                if(res.data.data.length > 0) this.product = res.data.data
                else this.product = [ { product: [] } ]
                console.log('Products : ', this.product)
            })
            .catch(err => {
                return err
                this.$swal(this.$t('error'), this.$t('error_text'), "error").then(this.clear())
            })
            this.loadingConsumenProduct = false
        },
		openDocumentBilling(keys, param = null){
			// this.product =  [ { product: [] } ],
			this.loadingLoadBilling = true
			this.totalBilling = 0
			this.priceCbp = 0
			this.priceUi = 0
			this.priceBi = 0
			this.totalCbp = 0
			this.totalUi = 0
			this.totalBi = 0
			this.totalPrice = 0
			// this.pph23 = 0
			console.log("key",keys)
			this.detailTopupData = keys
			console.log("key selecteed",this.detailTopupData)
			this.cusId = keys.customerId

			this.dialogDocumentBilling = true
			console.log("data prefix nya ",this.prefix)
			this.detailConsumenProduct()
			console.log("ini product nya bro",this.product)
			this.prefix.forEach(elePrefix => {
				console.log("ele prefix",elePrefix)
				const price_cbp = elePrefix.price_cbp
				const price_ui = elePrefix.price_ui
				const price_bi = elePrefix.price_bi
				this.priceCbp = price_cbp == 0 ? 0 : price_cbp
				this.priceUi = price_ui == 0 ? 0 : price_ui
				this.priceBi = price_bi == 0 ? 0 : price_bi
				// this.totalPrice = this.priceCbp+this.priceUi+this.priceBi

				console.log("price cbp",price_cbp)
				console.log("price ui",price_ui)
				console.log("price bi",price_bi)
				// console.log("total price",this.totalPrice)
			});
			
			this.detailTopupData.detail.forEach(element => {
				// console.log("element kebutuhan total",element)
				if(element.tokenType=="CBP"){
					const quota_cbp = element.quota
					console.log("quota cbp",quota_cbp)
					this.totalCbp = parseInt(this.priceCbp-element.discount) * parseInt(quota_cbp)
					console.log("total cbp",this.totalCbp)
				}
				if(element.tokenType=="UI"){
					const quota_ui = element.quota
					console.log("quota ui",quota_ui)
					this.totalUi = parseInt(this.priceUi-element.discount) * parseInt(quota_ui)
					console.log("discount ui",element.discount)
					console.log("total ui",this.totalUi)
				}
				if(element.tokenType=="BI"){
					const quota_bi = element.quota
					console.log("quota bi",quota_bi)
					this.totalBi = parseInt(this.priceBi-element.discount) * parseInt(quota_bi)
					console.log("total bi",this.totalBi)
				}

				this.totalPrice = this.totalCbp+this.totalUi+this.totalBi
				console.log("total price",this.totalPrice)

				// const price_ui = elePrefix.price_ui
				// const price_bi = elePrefix.price_bi
				// console.log("price cbp",price_cbp)
				// console.log("price ui",price_ui)
				// console.log("price bi",price_bi)
				// this.prefix.forEach(element_prefix => {
					// 	console.log("ini prefix nya",element_prefix)
				// });
			});
			// if(this.detailTopupData.topupType == "Added"){
			// 	this.settingForm.service_fee_add = 
			// }
			// if(this.totalCbp != "" || this.totalCbp != undefined || this.totalCbp != 0){
			// 	this.totalBilling = this.totalCbp
			// 	console.log("total billing nominal",this.totalBilling)
			// }
			// else if(this.totalUi != "" || this.totalUi != undefined || this.totalUi != 0){
			// 	this.totalBilling = this.totalUi
			// 	console.log("total billing nominal",this.totalBilling)
			// }
			// else if(this.totalBi != "" || this.totalBi != undefined || this.totalBi != 0){
			// 	this.totalBilling = this.totalBi
			// 	console.log("total billing nominal",this.totalBilling)
			// }
			// else if(totalCbp && totalUi && this.totalBi){
			// 	this.totalBilling = this.totalCbp+this.totalUi+this.totalBi
			// 	console.log("total billing nominal",this.totalBilling)
			// }
			// this.totalBill()
			let dataTax = this.setting[0]

			if (keys.tax_id && keys.tax_id != 'null') {

				let findTax = this.setting.find(el => el._id == keys.tax_id)
				if (findTax) {
					// this.settingForm.service_fee_add =  findTax.service_fee_add
					// this.settingForm.service_tax_add = findTax.service_tax_add
					// this.settingForm.pph_add = findTax.pph_add
					// this.settingForm.service_fee_minus = findTax.service_fee_minus
					// this.settingForm.service_tax_minus = findTax.service_tax_minus
					// this.settingForm.pph_min = findTax.pph_min

					dataTax = findTax
				}
			}

			if(keys.topupType == "Added"){
				this.settingForm.service_fee_add = Math.round(this.totalPrice*(dataTax.service_fee_add/100))
				this.settingForm.service_tax_add = Math.round((this.totalPrice+this.settingForm.service_fee_add)*dataTax.service_tax_add/100)
				this.settingForm.pph_add = Math.round((this.totalPrice+this.settingForm.service_fee_add)*dataTax.pph_add/100)
				// console.log("hasdjkajdkas",Math.ceil(this.totalPrice+this.settingForm.service_fee_add)*dataTax.service_tax_add/100)
				// var sf_add = Math.ceil(this.totalPrice*this.settingForm.service_fee_add)
				// var st_add = Math.ceil(this.totalPrice+this.settingForm.service_tax_add)*this.settingForm.service_tax_add
				this.totalBilling = this.formatPrice(this.totalCbp+this.totalUi+this.totalBi+this.settingForm.service_fee_add+this.settingForm.service_tax_add-this.settingForm.pph_add)
			}
			if(keys.topupType == "Minus"){
				this.settingForm.service_fee_minus = Math.round(this.totalPrice*(dataTax.service_fee_minus/100))
				this.settingForm.service_tax_minus = Math.round((this.totalPrice+this.settingForm.service_fee_minus)*dataTax.service_tax_minus/100)
				this.settingForm.pph_min = Math.round((this.totalPrice+this.settingForm.service_fee_add)*dataTax.pph_min/100)
				this.totalBilling = this.formatPrice(this.totalCbp+this.totalUi+this.totalBi+this.settingForm.service_fee_minus+this.settingForm.service_tax_minus-this.settingForm.pph_min)
			}
			console.log("total billing nominal",this.totalBilling)
			this.loadingLoadBilling = false
		},
		totalBill(){
			this.totalBilling = this.formatPrice(this.totalCbp+this.totalUi+this.totalBi)
			console.log("total billing nominal",this.totalBilling)
		},
		formatPrice(value) {
            // let val = (value/1).toFixed(2).replace('.', ',')
            if(typeof value == "string") value = parseFloat(value)

            if(value == null || value == "") value = 0
			return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
		},
		formatNumber(value) {
            // let val = (value/1).toFixed(2).replace('.', ',')
            if(typeof value == "string") value = parseFloat(value)

            if(value == null || value == "") value = 0
			return value.toLocaleString('id-ID', { minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		},
		handleChange(value) {
			this.ruleForm.num8 = value
      	},
		  approved(row){
			console.log('row selectd',row)
			this.$confirm(`Are you sure to approved this topup request?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingApproved = true
                await api({
                    url: config.baseApi + 'finance/request/approve/'+row.customerId,
                    method: 'post',
                    data: {
						requestId: row.requestId,
						topupStatus: row.topupStatus,
						customerName: row.customerName,
						productType: row.productType
                    }
                }).then(res => {
					console.log("res",res)
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success")
						this.getPendingTopup()
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingApproved=false
            })
		},
		rejected(row){
			console.log('row selectd',row)
			this.$confirm(`Are you sure to reject this topup request?`, 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true
			}).then(async () => {
                this.loadingRejected = true
                await api({
                    url: config.baseApi + 'finance/request/reject/'+row.customerId,
                    method: 'post',
                    data: {
                        id: row._id,
						topupStatus: row.topupStatus,
						customerName: row.customerName,
						customerNumber: row.customerNumber,
						productType: row.productType,
						detail: row.detail
                    }
                }).then(res => {
                    // this.loadingProduct=true
                    if(res.data.ec != 200){
						console.log("error disini")
                        this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    } else {
						console.log("sukses")
                        this.$swal(this.$t('success'), this.$t('success'), "success")
						this.getPendingTopup()
                    }
                }).catch(err => {
					console.log("error")
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    return err
                })
                this.loadingRejected=false
            })
		},
		  
		clickAddType(){
			this.ruleFormCaping.detail.push({
				tokenType: "",
				quota: "",
				// language: '',
				// messages: '',
				// body_text: [],
				// header: {
				// 	type: "none",
				// 	data: null,
				// 	// example: {
				// 	//     header_text: []
				// 	// }
				// },
				// footer: "",
				// buttons: {
				// 	type:"none"
				// },
				// action: [{
				// 	type: 'call',
				// 	text: '',
				// 	country: '',
				// 	phone: '',
				// 	url: ''
				// }],
				// quick: [{
				// 	text: '',
				// }],
				// url: [{
				// 	type: 'static',
				// 	link: ''
				// }]
			})

			// this.checkParam.push([])
			// this.checkParamHeader.push([])
			// this.checkParamBtn.push([])
			// this.counter.push(1)
			// this.counterHeader.push(1)
			// this.counterBtn.push(1)
		},
		deleteDataType(i){
            this.ruleFormCaping.detail.splice(i, 1)
        },
		async getPrefix(page = 1){
			this.loadingPrefix = true
            await api({
                url: config.baseApi + "prefix?page="+page+"&prefix_code=62",
                method: 'get'
            })
            .then(res => {
				if(res.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else {
					this.prefix = res.data.data.prefix
					console.log("prefix data",this.prefix)
					// this.total = res.data.data.total
				}
            })
            .catch(err => {

            })
            this.loadingPrefix = false
		},
        async loadCompany() {
            this.loadingNumber = true
			await api({
				method: 'get',
				url: config.baseApi +'finance'
			}).then(result => {
				if(result.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else{
					this.costumers = result.data.data.consumen
					this.total = result.data.data.total
				}

				if(this.total == 0){
						this.$swal(this.$t('error'), `None of the companies have notification_prepaid`, "error")
					}
			}).catch(error => {
				console.log('error', error);
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
			})
            this.loadingNumber = false
		},
        
		async loadCompanyCaping() {
			this.ruleFormCaping.selectedCompany = ''
			this.ruleFormCaping.selectedPhoneNumber = ''
            this.loadingNumberCaping = true
			await api({
				method: 'get',
				url: config.baseApi +'caping/'+this.ruleFormCaping.selectedProduct 
			}).then(result => {
				if(result.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				else{
					this.costumersCaping = result.data.data.consumen
					console.log("list customer caping",this.costumersCaping)
					this.totalCaping = result.data.data.total
				}

				if(this.totalCaping == 0){
					this.$swal(this.$t('error'), `None of the companies have ${this.ruleFormCaping.selectedProduct}`, "error")
				}
			}).catch(error => {
				console.log('error', error);
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
			})
            this.loadingNumberCaping = false
		},
		
		submitTopUp(formName){
			this.loadingBtn = true
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.formLoading = true
					if(formName == 'ruleFormCaping'){
						this.dialogCheckVisibleCaping = true
					}
					else {
						this.dialogCheckVisible = true
					}
					
				} else {
					console.log('error submit!!');
					return false;
				}
			});
			this.formLoading = false
            this.loadingBtn = false
		},

		async requestTopup(formName){
			const dataDetail = this.ruleFormCaping.detail
			console.log("data detail",dataDetail)
			const detailRequest = Object.assign([],dataDetail)
			console.log("detail request",detailRequest)
			detailRequest.forEach(eleDetail => {
				console.log("ele detail",eleDetail)
				if(this.ruleFormCaping.topuptype == "Added") {
					if(eleDetail.tokenType == "CBP"){
						console.log("ele detail quota",eleDetail.quota)
						eleDetail.quota_before_topup = this.dataQuota
						console.log("ele detail quota bt cbp",eleDetail.quota_before_topup)
						eleDetail.quota_after_topup = eleDetail.quota == 0 ? eleDetail.quota_before_topup : this.dataQuota+eleDetail.quota
						eleDetail.discount = this.discountCBP
					}
					if(eleDetail.tokenType == "UI"){
						console.log("ele detail quota",eleDetail.quota)
						eleDetail.quota_before_topup = this.dataQuotaUI
						console.log("ele detail quota bt ui",eleDetail.quota_before_topup)
						eleDetail.quota_after_topup = eleDetail.quota == 0 ? eleDetail.quota_before_topup : this.dataQuotaUI+eleDetail.quota
						eleDetail.discount = this.discountUI
					}
					if(eleDetail.tokenType == "BI"){
						console.log("ele detail quota",eleDetail.quota)
						eleDetail.quota_before_topup = this.dataQuotaBI
						console.log("ele detail quota bt bi",eleDetail.quota_before_topup)
						eleDetail.quota_after_topup = eleDetail.quota == 0 ? eleDetail.quota_before_topup : this.dataQuotaBI+eleDetail.quota
						eleDetail.discount = this.discountBI
					}
				}
				if(this.ruleFormCaping.topuptype == "Minus") {
					if(eleDetail.tokenType == "CBP"){
						eleDetail.quota_before_topup = this.dataQuota
						eleDetail.quota_after_topup = this.dataQuota-eleDetail.quota
						eleDetail.discount = this.discountCBP
					}
					if(eleDetail.tokenType == "UI"){
						eleDetail.quota_before_topup = this.dataQuotaUI
						eleDetail.quota_after_topup = this.dataQuotaUI-eleDetail.quota
						eleDetail.discount = this.discountUI
					}
					if(eleDetail.tokenType == "BI"){
						eleDetail.quota_before_topup = this.dataQuotaBI
						eleDetail.quota_after_topup = this.dataQuotaBI-eleDetail.quota
						eleDetail.discount = this.discountBI
					}
				}
			});

			this.submitreq = true
			this.$confirm(
				`Are you sure ?`,
				"Confirm",
				{
					confirmButtonText: "Yes",
					cancelButtonText: "No",
					type: "warning",
					center: true,
					dangerouslyUseHTMLString: true
				}
			)
			.then(async res => {
				console.log("res capcap",res)
				console.log("res final submit",formName)
				if(formName == 'ruleFormCaping'){
					await api({
						method: 'post',
						url: config.baseApi + 'caping/request-topup/' + this.ruleFormCaping.selectedCompany,
						data:{
							"type": this.ruleFormCaping.selectedProduct,
							"number": this.ruleFormCaping.selectedPhoneNumber,
							"detail": detailRequest,
							"responsible": this.user.name,
							"topup_type": this.ruleFormCaping.topuptype,
							"reason": this.ruleFormCaping.reason
						}
					}).then(result => {
						if(result.data.ec != 200){
							// alert("error")
							this.$swal(this.$t('error'), this.$t('error_text'), "error")
							this.submitreq = false
						}
						else{
							// alert("sukses")
							this.$swal(this.$t('success'), this.$t('success'), "success").then(this.resetForm())
							// this.getCapingQuota()
							this.resetForm()
							this.activeTab = "billing_quota"
							this.getHistory()
							this.getPendingTopup()
							this.submitreq = false
						}
						this.btnLoading = false
						this.dialogCheckVisibleCaping = false
					}).catch(error => {
						console.log('error', error);
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
						this.submitreq = false
					})
				}
				else{
					await api({
						method: 'post',
						url: config.baseApi + 'finance/submit/' + this.ruleForm.selectedCompany.customer_id,
						data:{
							"number": this.ruleForm.selectedPhoneNumber,
							"nominal": this.ruleForm.num8
						}
					}).then(result => {
						if(result.data.ec != 200){
							this.$swal(this.$t('error'), this.$t('error_text'), "error")
							this.submitreq = false
						}
						else{
							this.$swal(this.$t('success'), this.$t('success'), "success").then(this.resetForm())
							this.submitreq = false
						}
						this.submitreq = false
						this.dialogCheckVisible = false
					}).catch(error => {
						console.log('error', error);
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
						this.btnLoading = false
					})
				}
			})
			.catch(cancel => {
				this.submitreq = false
				this.dialogCheckVisible = false
				this.dialogCheckVisibleCaping = false
			})
		},

		async finalSubmit(rowAct){
			console.log(rowAct)
			const dataDetail = rowAct.detail
			const detailRequest = Object.assign([],dataDetail)
			console.log("data detail req",detailRequest)
			console.log("radio opt",this.radioOptions[0])

			detailRequest.forEach(eleDetail => {
				console.log("ele detail",eleDetail)
				if(this.ruleFormCaping.topuptype == "Added") {
					if(eleDetail.tokenType == "CBP"){
						console.log("ele detail quota",eleDetail.quota)
						eleDetail.quota_before_topup = this.dataQuota
						console.log("ele detail quota bt cbp",eleDetail.quota_before_topup)
						eleDetail.quota_after_topup = eleDetail.quota == 0 ? eleDetail.quota_before_topup : eleDetail.quota_before_topup+eleDetail.quota
						eleDetail.discount = this.discountCBP
					}
					if(eleDetail.tokenType == "UI"){
						console.log("ele detail quota",eleDetail.quota)
						eleDetail.quota_before_topup = this.dataQuotaUI
						console.log("ele detail quota bt ui",eleDetail.quota_before_topup)
						eleDetail.quota_after_topup = eleDetail.quota == 0 ? eleDetail.quota_before_topup : eleDetail.quota_before_topup+eleDetail.quota
						eleDetail.discount = this.discountUI
					}
					if(eleDetail.tokenType == "BI"){
						console.log("ele detail quota",eleDetail.quota)
						eleDetail.quota_before_topup = this.dataQuotaBI
						console.log("ele detail quota bt bi",eleDetail.quota_before_topup)
						eleDetail.quota_after_topup = eleDetail.quota == 0 ? eleDetail.quota_before_topup : eleDetail.quota_before_topup+eleDetail.quota
						eleDetail.discount = this.discountBI
					}
				}
				if(this.ruleFormCaping.topuptype == "Minus") {
					if(eleDetail.tokenType == "CBP"){
						eleDetail.quota_before_topup = this.dataQuota
						// eleDetail.quota_after_topup = this.dataQuota-eleDetail.quota
						eleDetail.quota_after_topup = eleDetail.quota == 0 ? eleDetail.quota_before_topup : eleDetail.quota_before_topup-eleDetail.quota
						eleDetail.discount = this.discountCBP
					}
					if(eleDetail.tokenType == "UI"){
						eleDetail.quota_before_topup = this.dataQuotaUI
						// eleDetail.quota_after_topup = this.dataQuotaUI-eleDetail.quota
						eleDetail.quota_after_topup = eleDetail.quota == 0 ? eleDetail.quota_before_topup : eleDetail.quota_before_topup-eleDetail.quota
						eleDetail.discount = this.discountUI
					}
					if(eleDetail.tokenType == "BI"){
						eleDetail.quota_before_topup = this.dataQuotaBI
						// eleDetail.quota_after_topup = this.dataQuotaBI-eleDetail.quota
						eleDetail.quota_after_topup = eleDetail.quota == 0 ? eleDetail.quota_before_topup : eleDetail.quota_before_topup-eleDetail.quota
						eleDetail.discount = this.discountBI
					}
				}
			});
			
			this.loadingApproved = true
			this.$confirm(
					`Are you sure ?`,
					"Confirm",
					{
					confirmButtonText: "Yes",
					cancelButtonText: "No",
					type: "warning",
					center: true,
					dangerouslyUseHTMLString: true
					}
				)
				.then(async res => {
					console.log("res capcap",res)
					// if(formName == 'ruleFormCaping'){
						await api({
							method: 'post',
							url: config.baseApi + 'caping/update-quota/' + rowAct.customerId,
							data:{
								"productName": this.ruleFormCaping.selectedProductName,
								"requestId": rowAct.requestId,
								"type": rowAct.productType,
								"number": rowAct.customerNumber,
								"detail": detailRequest,
								"responsible": this.user.name,
								"topup_type": rowAct.topupType,
								"reason": rowAct.reason,
								// "actionRequest": rowAct.topupType == "Added" ? "Approved" : "Rejected",
								"actionRequest": this.radioOptions[0],
								"tax_id": this.setting[0]._id || null
							}
						}).then(result => {
							if(result.data.ec != 200){
								this.$swal(this.$t('error'), this.$t('error_text'), "error")
							}
							else{
								this.$swal(this.$t('success'), this.$t('success'), "success").then(this.resetForm())
								// this.getCapingQuota()
								this.resetForm()
								this.activeTab = "history_finance"
								this.getHistory()
							}
							this.loadingApproved = false
							this.dialogCheckVisibleCaping = false
						}).catch(error => {
							console.log('error', error);
							this.$swal(this.$t('error'), this.$t('error_text'), "error")
							this.loadingApproved = false
						})
					// }
					// else{
					// 	await api({
					// 		method: 'post',
					// 		url: config.baseApi + 'finance/submit/' + this.ruleForm.selectedCompany.customer_id,
					// 		data:{
					// 			"number": this.ruleForm.selectedPhoneNumber,
					// 			"nominal": this.ruleForm.num8
					// 		}
					// 	}).then(result => {
					// 		if(result.data.ec != 200){
					// 			this.$swal(this.$t('error'), this.$t('error_text'), "error")
					// 		}
					// 		else{
					// 			this.$swal(this.$t('success'), this.$t('success'), "success").then(this.resetForm())
					// 		}
					// 		this.btnLoading = false
					// 		this.dialogCheckVisible = false
					// 	}).catch(error => {
					// 		console.log('error', error);
					// 		this.$swal(this.$t('error'), this.$t('error_text'), "error")
					// 		this.btnLoading = false
					// 	})
					// }
				})
				.catch(cancel => {
					this.loadingApproved = false
					this.dialogCheckVisible = false
					this.dialogCheckVisibleCaping = false
				})
		},

		async getSaldo(){
			this.saldoLoading = true
			await api({
				method: 'get',
				url: config.baseApi + 'finance/saldo/' + this.ruleForm.selectedCompany.customer_id + '/' + this.ruleForm.selectedPhoneNumber,
			}).then(result => {
				if(result.data.ec == 200){
					if(result.data.data.responseCode == "000"){
						this.dataSaldo = result.data.data.data.saldo
					}
					else{
						this.$swal(this.$t('error'), this.$t('error_text'), "error")
						this.dataSaldo = 'ERROR'
					}
				}
				else{
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
					this.dataSaldo = 'ERROR'
				}
				this.saldoLoading = false
			}).catch(error => {
				console.log('error', error);
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
				this.dataSaldo = 'ERROR'
				this.saldoLoading = false
			})
		},

		async getCapingQuota(){
			this.saldoLoading = true
			await api({
				method: 'get',
				url: config.baseApi + 'caping/quota/' + this.ruleFormCaping.selectedCompany + '/' + this.ruleFormCaping.selectedPhoneNumber + '/'+this.ruleFormCaping.selectedProductName +'/'+ this.ruleFormCaping.selectedProduct,
			}).then(result => {
				console.log("result",result)
				if(result.data.ec == 200 && result.data.data != null){
					let data = result.data.data.filter(el => el.length != 0)
					this.dataQuota = data[0][0].count
					this.dataQuotaUI = data[0][0].count_ui
					this.dataQuotaBI = data[0][0].count_bi
					this.discountCBP = data[0][0].prefix[0].discount.cbp.value != undefined ? data[0][0].prefix[0].discount.cbp.value : this.discountCBP
					console.log("discount cbp",this.discountCBP)
					
					this.discountUI = data[0][0].prefix[0].discount.ui.value != undefined ? data[0][0].prefix[0].discount.ui.value : this.discountUI
					console.log("discount ui",this.discountUI)
					
					this.discountBI = data[0][0].prefix[0].discount.bi.value != undefined ? data[0][0].prefix[0].discount.bi.value : this.discountBI
					console.log("discount bi",this.discountBI)
					if(this.dataQuota == null){
						this.dataQuota = 0
					}
					if(this.dataQuotaUI == null){
						this.dataQuotaUI = 0
					}
					if(this.dataQuotaBI == null){
						this.dataQuotaBI = 0
					}
				}
				else{
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
					this.dataQuota = 'ERROR'
					this.dataQuotaUI = 'ERROR'
					this.dataQuotaBI = 'ERROR'
				}
				this.saldoLoading = false
			}).catch(error => {
				console.log('error', error);
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
				this.dataQuota = 'ERROR'
				this.dataQuotaUI = 'ERROR'
				this.dataQuotaBI = 'ERROR'
				this.saldoLoading = false
			})
		},

		async getPendingTopup(){
			this.pendingLoading = true
			await api({
				method: 'get',
				url: config.baseApi + 'finance/pending',
			}).then(result => {
				if(result.data.ec == 200){
					this.totalPendingStatus = result.data.data.total
					this.pendingRequest = result.data.data.pending_status
					console.log('pending request',this.pendingRequest)
				}
				else{
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				this.pendingLoading = false
			}).catch(error => {
				console.log('error', error);
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
				this.pendingLoading = false
			})
		},

		async getHistory(){
			this.historyLoading = true
			await api({
				method: 'get',
				url: config.baseApi + 'finance/history',
			}).then(result => {
				if(result.data.ec == 200){
					this.totalHistory = result.data.data.total
					this.history = result.data.data.history
					// function subTotal(items) {
					// this.history.forEach(element => {
					// 	element.detail.reduce((acc, ele) => {
					// 		console.log("acc",acc)
					// 		console.log("ele reducee",acc+parseInt(ele.quota))
					// 		// return acc + parseInt(ele.bfloorArea);
					// 	}, 0);
					// });
					// }
					console.log('history fin',this.history)
				}
				else{
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				}
				this.historyLoading = false
			}).catch(error => {
				console.log('error', error);
				this.$swal(this.$t('error'), this.$t('error_text'), "error")
				this.historyLoading = false
			})
		},

		resetForm() {
			// this.$refs[formName].resetFields();
			// this.ruleFormCaping.selectedProduct = "notification_caping_plafon",
			// this.ruleFormCaping.selectedCompany = "",
			// this.ruleFormCaping.selectedPhoneNumber = "",
			this.ruleFormCaping.quota = ''
			this.dataSaldo = ''
			this.dataCapingQuota = ''
			this.ruleFormCaping.topuptype = "Added"
			this.ruleFormCaping.tokenType = ''
			this.ruleFormCaping.reason = ""

			this.ruleFormCaping.selectedProductName = "Whatsapp Conversation"
			this.ruleFormCaping.selectedProduct = "notification_caping_plafon"
			// this.ruleFormCaping.selectedCompany = ""
			// this.ruleFormCaping.selectedPhoneNumber = ""
			this.ruleFormCaping.detail[0].tokenType = "CBP"
			this.ruleFormCaping.detail[0].quota_before_topup = 0
			this.ruleFormCaping.detail[0].quota = 0
			this.ruleFormCaping.detail[0].quota_after_topup = 0
			this.ruleFormCaping.detail[0].discount = 0
			
			this.ruleFormCaping.detail[1].tokenType = "UI"
			this.ruleFormCaping.detail[1].quota_before_topup = 0
			this.ruleFormCaping.detail[1].quota = 0
			this.ruleFormCaping.detail[1].quota_after_topup = 0
			this.ruleFormCaping.detail[1].discount = 0

			this.ruleFormCaping.detail[2].tokenType = "BI"
			this.ruleFormCaping.detail[2].quota_before_topup = 0
			this.ruleFormCaping.detail[2].quota = 0
			this.ruleFormCaping.detail[2].quota_after_topup = 0
			this.ruleFormCaping.detail[2].discount = 0
			
			this.ruleFormCaping.total_nominal = 0
		}
      
    },
   	mounted(){
		// this.loadCompany()
		this.getPendingTopup()
		this.loadCompanyCaping()
		this.getPrefix()
		this.getSetting()
    },
    computed: {
        number: function(){
			return this.ruleForm.selectedCompany.data_product
        },

        numberCaping: function(){
			if(this.ruleFormCaping.selectedCompany != ''){
				this.ruleFormCaping.selectedPhoneNumber = ''
				let fill = this.costumersCaping.filter((el) => el.customer_id == this.ruleFormCaping.selectedCompany)
				return fill[0].data_product
			}
			else {
				return ''
			}
			// return this.ruleFormCaping.selectedCompany.data_product
        },

		capingCompany: function(){
			if(this.ruleFormCaping.selectedCompany != ''){
				let fill = this.costumersCaping.filter((el) => el.customer_id == this.ruleFormCaping.selectedCompany)
				return fill[0].customer_name
			}
			else {
				return ''
			}
        },

		saldo: function(){
			this.getSaldo()
		},

		quota: function(){
			this.getCapingQuota()
		}
    }
}
</script>
<style scoped>
.swal2-container {
	z-index: 10000 !important;
}

.img-center {
    display: block;
    margin-bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    width: 50%;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #ffffff;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
table th {
  background: #79DFFF;
  color: black;
  font-weight: bold;
  /* font-size: 18px; */
}
/* .css-serial { */
  /* counter-reset: serial-number;  Atur penomoran ke 0 */
/* } */
/* .css-serial td:first-child:before { */
  /* counter-increment: serial-number;  Kenaikan penomoran */
  /* content: counter(serial-number);  Tampilan counter */
/* } */
</style>
<style lang="scss">
@import '../assets/scss/_variables';

.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}

.row {
	margin-top: 30px;
}

.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			float: right;
			margin-bottom: 30px;

			.logo {
				float: right;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}
}
</style>
